import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// salary_slips — สลิปเงินเดือน (Salary Slip)
// ============================================================================
export const salarySlips = sqliteTable("hr_salary_slips", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  slipNo: text("slip_no").notNull(),
  payrollEntryId: text("payroll_entry_id").notNull(),
  employeeId: text("employee_id").notNull(),
  employeeCode: text("employee_code"),
  employeeName: text("employee_name"),
  departmentId: text("department_id"),
  designationId: text("designation_id"),
  baseSalary: real("base_salary").notNull().default(0),
  totalEarnings: real("total_earnings").notNull().default(0),
  totalDeductions: real("total_deductions").notNull().default(0),
  netPay: real("net_pay").notNull().default(0),
  // Statutory deductions
  incomeTax: real("income_tax").notNull().default(0),          // ภาษีหัก ณ ที่จ่าย
  socialSecurity: real("social_security").notNull().default(0), // ประกันสังคม (max 750)
  providentFund: real("provident_fund").notNull().default(0),   // กองทุนสำรองเลี้ยงชีพ
  // Earnings/Deductions breakdown (JSON)
  earningsDetail: text("earnings_detail"),    // JSON: [{name, amount}]
  deductionsDetail: text("deductions_detail"), // JSON: [{name, amount}]
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  sslip_payroll_idx: index("sslip_payroll_idx").on(table.payrollEntryId),
  sslip_employee_idx: index("sslip_employee_idx").on(table.companyId, table.employeeId),
  sslip_company_idx: index("sslip_company_idx").on(table.companyId),
}));

// Type exports
export type SalarySlip = typeof salarySlips.$inferSelect;
export type NewSalarySlip = typeof salarySlips.$inferInsert;
